import { call, put, select } from "redux-saga/effects";
import axios from "../../config/axiosConfig";
import { TOAST_SHOW } from "../actions/toastActions";
import { ERROR_CODES } from '../../constants/errorCodes';

import { CALL_EVENT_SUCCESS, CALL_EVENT_ERROR, FETCH_GAME_DATA_SUCCESS, FETCH_GAME_DATA_ERROR, FETCH_GAME_DATA_UNCHANGED, GET_LEADERBOARD_SUCCESS, GET_LEADERBOARD_ERROR, GET_DEV_DETAIL_SUCCESS, GET_DEV_DETAIL_FAILED, GET_DEV_DETAIL_UNCHANGED, GAME_RATING_SUCCESS, GAME_RATING_FAILED, GET_ACHIEVEMENTS_SUCCESS, GET_ACHIEVEMENTS_FAILED, CHECK_GAME_PARTICIPATION_SUCCESS, CHECK_GAME_PARTICIPATION_FAILED, GET_APP_BY_TAG_SUCCESS, GET_APP_BY_TAG_FAILED, GET_APP_BY_TAG_UNCHANGED, GET_APP_PRODUCT_DETAIL_SUCCESS, GET_APP_PRODUCT_DETAIL_FAILED, GET_APP_PRODUCTS_SUCCESS, GET_APP_PRODUCTS_FAILED, GET_APP_USERRATED_DETAIL_SUCCESS, GET_APP_USERRATED_DETAIL_FAILED, GAME_PURCHASE_SUCCESS, GAME_PURCHASE_FAILED, GAME_SCORE_SUBSTRACT_SUCCESS, GAME_SCORE_SUBSTRACT_FAILED, FETCH_BALANCE_FAILED, FETCH_BALANCE_SUCCESS } from "../actions/gameActions";
import { contentCacheRepository } from "../../services/contentCacheRepository";
import { runCachedContentRequest } from "./contentCacheSaga";
 
export function* triggerEventsSaga({ payload, callback }) { 
	const url = `/api/events?t=${Date.now()}`; 
	try {
	  const { data, status } = yield call(axios.post, url, payload);
	  if (status === 200) {
		yield put({ type: CALL_EVENT_SUCCESS, payload: data, gameId: payload?.event_value });
		if (callback) callback(true);
	  }
	} catch {
	  yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4001}: Something went wrong please try again`, severity: "Danger", show: true, }});
	  yield put({ type: CALL_EVENT_ERROR });
	}
}
export function* fetchGameAppDataSaga({ payload,callback,errorCallback,requestKey }) {
	const appId = payload?.app_id;
	const result = yield* runCachedContentRequest({
		resource: "game",
		params: { appId: String(appId ?? "") },
		requestKey: requestKey || `game:${String(appId ?? "")}`,
		fetchRequest: () => axios.post(`/api/app?t=${Date.now()}`, payload),
		cacheSuccessType: FETCH_GAME_DATA_SUCCESS,
		networkSuccessType: FETCH_GAME_DATA_SUCCESS,
		unchangedType: FETCH_GAME_DATA_UNCHANGED,
		errorType: FETCH_GAME_DATA_ERROR,
	});
	if (result?.response && callback) {
		callback(result.response.data);
	}
	if (result?.error) {
		if (!result.hasCachedData) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4002}: Something went wrong please try again`, severity: "Danger", show: true} }); 
		}
		if (errorCallback) errorCallback(result.error);
	}
}

export function* fetchLeaderboardSaga(action) {
	const { payload } = action; 
	const url = `/api/leaderboard?t=${Date.now()}`;
	try {
		const response = yield call( axios.post, url , payload ); 
		if (response?.status === 200) {
			const { data } = response;
			yield put({ type: GET_LEADERBOARD_SUCCESS,  payload: data });
		}
	} catch (e) {
		yield put({  type: TOAST_SHOW,  payload: { message: `${ERROR_CODES.E4003}: Something went wrong please try again`, severity: "Danger", show: true} }); 
		yield put({  type: GET_LEADERBOARD_ERROR });
	}
}

export function* getDevDetailsSaga({ payload, callback }) {
	const developerId = payload?.developer;
	const result = yield* runCachedContentRequest({
		resource: "developer",
		params: { developerId: String(developerId ?? "") },
		requestKey: `developer:${String(developerId ?? "")}`,
		fetchRequest: () => axios.post(`/api/devList?t=${Date.now()}`, payload),
		cacheSuccessType: GET_DEV_DETAIL_SUCCESS,
		networkSuccessType: GET_DEV_DETAIL_SUCCESS,
		unchangedType: GET_DEV_DETAIL_UNCHANGED,
		errorType: GET_DEV_DETAIL_FAILED,
	});
	if (result?.response && callback) {
		callback(true);
	}
	if (result?.error && !result.hasCachedData) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4004}: Something went wrong please try again`, severity: "Danger", show: true}}); 
	}
}

export function* appRatingSaga({ payload, callbackFun }) { 
	let updateGameDetail;
	const url  = `/api/app/rating?t=${Date.now()}`;
	try {
		const response = yield call( axios.post, url , payload ); 
		if (response?.status === 200) {
			const { data } = response;
			yield put({ type: GAME_RATING_SUCCESS, payload: data });  
			const userScope = yield select((state) => String(state?.Auth?.user?.id || "guest"));
			yield call([contentCacheRepository, contentCacheRepository.invalidate], {
				resource: "game",
				userScope,
				predicate: (entry) => String(entry?.params?.appId ?? "") === String(payload?.app_id ?? payload?.appId ?? ""),
			});
			updateGameDetail=true;
		}
	} catch (e) {
		if(e?.response?.status ===400){
			yield put({ type: TOAST_SHOW, payload: { message: e?.response?.data , severity: "Danger", show: true } }); 
		}else{
			yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4005}: Something went wrong please try again`, severity: "Danger", show: true } }); 
		}
		yield put({ type: GAME_RATING_FAILED });
		updateGameDetail=false;
	}
	if (callbackFun) callbackFun(updateGameDetail);

}

export function* getAchievementsSaga({ payload }) {  
	const url  =  `/api/get_all_achievement?t=${Date.now()}`;
	try {
		const response = yield call(axios.post, url , payload); 
		if (response?.status === 200) {
			const { data } = response;
			yield put({ type:GET_ACHIEVEMENTS_SUCCESS, payload: data }); 
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4006}: Something went wrong please try again`, severity: "Danger", show: true } });
		yield put({ type: GET_ACHIEVEMENTS_FAILED });
	}
}

 
export function* fetchBalanceSagaNotInUse(action) {  
	const url = `/api/balance?t=${Date.now()}`;
	try {
		const response = yield call(axios.get, url); 
		if (response?.status === 200) {
			const { data } = response ;
			yield put({ type:FETCH_BALANCE_SUCCESS, payload: data }); 
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E1002}: Something went wrong please try again`, severity: "Danger", show: true } });
		yield put({ type: FETCH_BALANCE_FAILED });
	}
}


export function* checkGameParticipationSaga({payload,callbackFun,blockParticipationCallbackFun,errorCallback}) { 
	const url = `/api/check_participation?t=${Date.now()}`;
	try {
		const response = yield call( axios.post, url, payload );  

		if (response?.status === 200) {
			const { data } = response;
			yield put({ type: CHECK_GAME_PARTICIPATION_SUCCESS, payload: data });  
			const userScope = yield select((state) => String(state?.Auth?.user?.id || "guest"));
			yield call([contentCacheRepository, contentCacheRepository.invalidate], {
				userScope,
				predicate: (entry) => ["game", "home", "section", "category"].includes(entry.resource),
			});
			
			if(callbackFun && data?.valid){
				callbackFun();
			}else{
				if(blockParticipationCallbackFun){
					blockParticipationCallbackFun(data);
				}
			} 
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4007}: Something went wrong please try again`, severity: "Danger", show: true }});
		yield put({ type: CHECK_GAME_PARTICIPATION_FAILED });
		if (errorCallback) errorCallback(e);
	}
}

export function* fetchGameByTagSaga({ payload }) {
	const tagName = payload?.tag_name;
	const result = yield* runCachedContentRequest({
		resource: "tag",
		params: { tagName: String(tagName ?? "") },
		requestKey: `tag:${String(tagName ?? "")}`,
		fetchRequest: () => axios.post(`/api/tagapps?t=${Date.now()}`, payload),
		cacheSuccessType: GET_APP_BY_TAG_SUCCESS,
		networkSuccessType: GET_APP_BY_TAG_SUCCESS,
		unchangedType: GET_APP_BY_TAG_UNCHANGED,
		errorType: GET_APP_BY_TAG_FAILED,
	});
	if (result?.error && !result.hasCachedData) {
		yield put({ type: TOAST_SHOW, payload: {message: `${ERROR_CODES.E4008}: Something went wrong please try again`,severity: "Danger",show: true}});
	}
}

export function* getAppProductDetailSaga({ payload }) {
	const url  = `/api/appProduct?t=${Date.now()}`;
	try {
		const response = yield call(axios.post, url ,payload); 
		if (response?.status === 200) {
			const { data } = response;
			yield put({type: GET_APP_PRODUCT_DETAIL_SUCCESS,payload: data});
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: {message: `${ERROR_CODES.E4009}: Something went wrong please try again`,severity: "Danger",show: true}});
		yield put({ type: GET_APP_PRODUCT_DETAIL_FAILED });
	}
}

export function* getAppProductsSaga({ payload }) {
	const url = `/api/appProducts?t=${Date.now()}`;
	try {
		const response = yield call(axios.post, url , payload); 
		if (response?.status === 200) {
			const { data } = response;
			yield put({type: GET_APP_PRODUCTS_SUCCESS,payload: data});
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4010}: Something went wrong please try again`,severity: "Danger",show: true }});
		yield put({ type: GET_APP_PRODUCTS_FAILED });
	}
}

export function* getGameUserRatedDetailSaga({ payload }) {
	const url = `/api/app/user_rated?t=${Date.now()}`;
	try {
		const response = yield call( axios.post, url , payload);
		if (response.status === 200) {
			const { data } = response;
			yield put({ type: GET_APP_USERRATED_DETAIL_SUCCESS, payload: data });
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4011}: Something went wrong please try again`, severity: "Danger", show: true } });
		yield put({ type: GET_APP_USERRATED_DETAIL_FAILED });
	}
}

export function* gamePurchaseSaga({ payload }) { 
	const url = `/api/purchase?t=${Date.now()}`;
	try {
		const response = yield call(axios.post, url , payload);
		if (response?.status === 200) {
			const { data } = response;
			yield put({ type: GAME_PURCHASE_SUCCESS, payload: data });
		}
	} catch (e) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E4012}: Something went wrong please try again`, severity: "Danger", show: true } });
		yield put({ type: GAME_PURCHASE_FAILED });
	}
}

export function* substractScoreSaga({ payload }) {
	const url = `/api/substract`;
	try{
		const response = yield call(axios.post, url, payload);
		if(response.status ===200){
			const { data } = response;
			yield put({ type:GAME_SCORE_SUBSTRACT_SUCCESS, payload: data })
		}
	} catch (e) {
		yield put({ type:TOAST_SHOW,payload:{message:`${ERROR_CODES.E4013}: Something went wrong please try again`,severity: "Danger",show: true }});
		yield put({ type: GAME_SCORE_SUBSTRACT_FAILED })
	}
}
